<template>
  <div class="tooltip-body">
    <div class="tooltip-body__info">
      {{ $t("message.sentiment.heatmap.tooltipClickInfo") }}
    </div>
    <div class="tooltip-body__header">
      <span> {{ categoryName }}: </span>
      <span>{{ reviewCountLabel }}</span>
    </div>

    <div class="tooltip-body__section-name">
      {{ $t("message.sentiment.sentimentName") }}
    </div>

    <div
      v-for="(sentiment, key) in sentiments"
      :key="key"
      class="tooltip-body__row"
    >
      <span>{{ sentimentTranslations[key] }}:</span>
      <b>{{ sentimentPercentage(sentiment) }}% ({{ sentiment.number }})</b>
    </div>
  </div>
</template>

<script>
import { pluralCount } from "@/helpers/helpers";

export default {
  name: "ReviewsCategoriesHeatmapTooltip",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    categoryName() {
      return this.data.name || this.$t("message.common.reviewsWithoutCategory");
    },
    reviewCountLabel() {
      return pluralCount("message.pluralForms.review", this.data.count);
    },
    sentiments() {
      const { positive, negative, neutral, unassigned } = this.data;
      return { positive, negative, neutral, unassigned };
    },
    sentimentTranslations() {
      return {
        positive: this.$t("message.sentiment.positive"),
        negative: this.$t("message.sentiment.negative"),
        neutral: this.$t("message.sentiment.neutral"),
        unassigned: this.$t("message.sentiment.unassigned")
      };
    }
  },
  methods: {
    sentimentPercentage(sentiment) {
      return Math.round(sentiment.percentage);
    }
  }
};
</script>
<style lang="scss" scoped>
.tooltip-body {
  &__info {
    background: rgba(255, 255, 255, 0.125);
    padding: 0 $spacing;
    border-radius: 24px;
    @include font-size(12px);
    margin-bottom: $spacing * 2.25;
  }

  &__header,
  &__section-name {
    @include font-size(14px);
    font-weight: bold;
  }

  &__header {
    margin-bottom: $spacing * 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: $spacing * 1.5;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    gap: $spacing * 1.5;
  }

  &__label {
    @include font-size(14px);
    display: flex;

    & > div {
      flex-grow: 1;
    }
    &--small {
      &:first-of-type {
        margin-top: $spacing;
      }

      line-height: 0.8rem;
      @include font-size(10px);
    }
  }
}
</style>
